import React, { createElement } from 'react';

import type { ModalLink as ModalLinkModel } from 'api/contentful/contentTypes.cloverdotcom';
import { workaroundRef } from 'components/TrackedLink/Util';
import { getField, getSys, isEntry } from 'utils/EntryUtil';

import { testAttribute } from 'utils/DataTestId';
import type { DynamicModalContext } from '../DynamicModal/useDynamicModals';
import { withDynamicModal } from '../DynamicModal/WithDynamicModal';
import { NestedLink } from '../NestedRoute/NestedLink';
import type { IContentLink } from './IContentLink';

interface IModalLink extends IContentLink<ModalLinkModel> {
  add: DynamicModalContext['add'];
  titleTag?: string;
}

class ModalLink extends React.PureComponent<IModalLink> {
  componentDidMount() {
    this.props.add(getField(this.props.entry, 'modal'));
  }

  render() {
    const { entry, innerRef, hideTitle, children, add, titleTag = 'span', ...props } = this.props;

    const modal = getField(entry, 'modal');

    if (!isEntry(modal) || getField(entry, 'hideButton')) return null;

    const title = getField(entry, 'title');
    const dataTestId = `${modal.fields.slug}-${testAttribute(title)}`;
    const titleLabel = !hideTitle && title && createElement(titleTag, { 'data-testid': dataTestId }, title);
    const ariaLabel = (!titleLabel && !children && title) || undefined;

    return (
      <NestedLink
        nestedTo={`/m/${getField(modal, 'slug') || getSys(entry, 'id')}`}
        innerRef={el => workaroundRef(el, innerRef)}
        aria-label={ariaLabel}
        {...props}
      >
        {titleLabel}
        {children}
      </NestedLink>
    );
  }
}

const DynamicModaled = withDynamicModal(({ add }) => ({ add }))(ModalLink);

export { DynamicModaled as ModalLink, ModalLink as _ModalLink };
